module.exports = __webpack_public_path__ + "static/img/hausn1.224750e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/handwerk/hausn1.jpg
// module id = 6pYB
// module chunks = 1